import React from "react";
import { RequireStaff } from "@/components/RequireStaff";

export default function StaffOperations() {
  return (
    <RequireStaff>
      <div className="font-['Geist',sans-serif]">
        <h1 className="text-xl font-semibold mb-4">Operations</h1>
        <div className="rounded-2xl p-5 space-y-2" style={{ background: "#1b2a3a" }}>
          <div className="rounded-xl p-4 bg-white/5 text-sm text-gray-300">
            Email templates • NDA/LOI templates • Feature flags
          </div>
        </div>
      </div>
    </RequireStaff>
  );
}
